import reportersApi from "@/api/reporters/Reporters" ;

// initial state
const state = {
    currentCompany: null,
    companies: null 
};

// getters
const getters = {

    currentCompany(state){
        return state.currentCompany
    },

    companies(state){
        return state.companies
    },

};

// actions
const actions = {

    setCompany ({ commit }, company) {
        
        commit('reporters/set_reporters', null, { root: true })
        commit('reporters/set_devices', null, { root: true })
        commit('reporters/set_alarms', [], { root: true })

        commit('setCompany', company) ; 

        let api = new reportersApi() ;

        api.set_company_id(company.id);

        return api.get().then(data => {
            return data ;
        })

    },

}

// mutations
const mutations = {

    setCompanies(state, companies){

        state.companies = companies ;

    },

    setCompany(state, company){

        state.currentCompany = company ;

        localStorage.currentCompany = JSON.stringify(company) ;

    }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}